import React, {useEffect, useState} from "react";
import PageHeader from "components/PageHeader";
import Section from "components/Section";
import Button from "components/Button";
import Img from "components/Img";

import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import 'assets/css/Gallery.min.css';

import { Gallery, Item } from 'react-photoswipe-gallery'
import clg from "functions/log";
import makeid from "functions/makeid";
import settings from "configs/settings";
import req from "functions/req";
import useDidMountEffect from "functions/useDidMountEffect";

const GalleryC = () => {

    const renderNumAtTime = 9;
    const [images, setImages] = useState([]);
    const [galleryItems, setGalleryItems] = useState([]);
    const [render, setRender] = useState(1);
    const [moreBtnDisabled, setMoreBtnDisabled] = useState(false);

    useDidMountEffect(() => {
        renderGalleryItems();
    },[render]);

    useDidMountEffect(() => {
        renderGalleryItems();
    },[images]);


    useEffect(() => {
        get();

        return () => {
            setGalleryItems([]);
            setRender(1);
            setImages([]);
        }
    },[]);

    
    const get = () => {
        req({ url : settings.req.gallery, method : "GET" }).then(function(res){
            clg("GALLERY RES: ", res);
            if( res && res.success ) {
                if( res.data && res.data.length ) {
                    let _images = [];
                    for(let index in res.data){
                        const curr = res.data[index];
                        _images.push( { url : curr } );
                    }
                    setImages( _images );
                }
            }
        });
    }

    const renderGalleryItems = () => {

        const allNum = images.length;
        const to = render * renderNumAtTime;
        const from = to - renderNumAtTime; 

        for(let i=from; i < to; i++){

            if( i <= allNum - 1 && typeof images[i] !== "undefined") {
                const curr = images[i];
                const single = 
                    <div className="col-lg-4 col-md-6 col-12 gallery-item" key={`gallery-item-${i + makeid()}`}>
                        <Item
                            original={curr.url}
                            thumbnail={curr.url}
                            width="1024"
                            height="768"
                            onChange={(e) => clg("asdsd",e)}
                            >
                            {({ ref, open }) => (
                                <div className="d-contents h-100 w-100" ref={ref}>
                                    <Img onClick={open} src={curr.url} skeletonprops={{ height: 300 }}/>
                                </div>
                            )}
                        </Item>
                    </div>

                setGalleryItems((prev) => [
                    ...prev,
                    single
                ]);
            } else {
                //Ha már az összes érték le van renderelve
                if( !moreBtnDisabled ) setMoreBtnDisabled(true);
            }
        }
    }

    return (
        <>
            <PageHeader/>

            <Section>
                <div className="row gallery-row">
                    <Gallery
                        closeButtonCaption="Bezárás"
                        shareButton={false}
                        fullscreenButton={false}
                        nextButtonCaption="Következő"
                        prevButtonCaption="Előző"
                    >
                        
                        {galleryItems}
                        
                    </Gallery>

                    <div className="col-12 d-flex justify-content-center">
                        <Button className="btn-secondary max-width-100" text="Továbbiak megjelenítése" disabled={ moreBtnDisabled } onClick={ () => setRender(render+1)} />
                    </div>
                </div>
            </Section>
        </>
    )
}

export default GalleryC;